export default __webpack_public_path__ + "static/media/babel.64d24e9d.jpg";